import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CONFIGURATOR_BANNER_MAP } from '@obo-app/common/shared/models/crossSelling.model';
import { SidebarComponent } from '@obo-common/shared/components/sidebar/sidebar.component';
import { ExtendedPlanning } from '@obo-dashboard/models/projectManagement.models';
import { Module } from '@obo-main/services/modules/module.models';
import { Constants } from '@obo-app/constants';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'app-configurator-detail-bar',
    templateUrl: './configurator-detail-bar.component.html',
    styleUrl: './configurator-detail-bar.component.scss',
    standalone: false
})
export class ConfiguratorDetailBarComponent {
    @Output()
    public configuratorNonMobile: EventEmitter<any> = new EventEmitter();
    public selectedItem: ExtendedPlanning | Module;
    public banner = CONFIGURATOR_BANNER_MAP;

    @ViewChild(SidebarComponent)
    public sidebar: SidebarComponent;
    protected isDraft = false;
    private isMobile: boolean = false;

    constructor(private stateService: StateService) {}

    public toggleSidebar(event: ExtendedPlanning | Module, isMobile: boolean, isDraft?: boolean): void {
        this.selectedItem = event;
        this.isMobile = isMobile;
        this.isDraft = isDraft;
        this.sidebar.toggle();
    }

    protected isPlanning(): boolean {
        return this.selectedItem instanceof ExtendedPlanning;
    }

    protected get selectedItemAsPlanning(): ExtendedPlanning {
        return this.selectedItem as ExtendedPlanning;
    }

    public forwardIfAllowed(): void {
        if (this.isMobile && Constants.DesktopOnlyModules.some((m) => m === this.selectedItem.id)) {
            this.configuratorNonMobile.emit();
        } else {
            this.stateService.go(this.selectedItem.name, { isDraft: this.isDraft });
        }
    }
}
